/* istanbul ignore file */
export enum HolderTypeEnum {
	TENANT = 'tenant',
	AGENCY = 'agency'
}
